// See https://docs.djangoproject.com/en/5.1/topics/i18n/translation/ for documentation on this Django i18n API

export const gettext = (text: string) => window.gettext(text);

// Disambiguates a msgid that means different things in different places. Django's
// JavaScriptCatalog already serves `pgettext` (it keys the catalog on `context + "\x04" + msgid`
// and falls back to the msgid on a miss), so this is a passthrough like `gettext` above.
//
// Needed because "Notes" is already the case-level notes card and tab, translated "Notizen", and
// the item-notes navbar area must read "Vermerke" (86bc2hd30). Before this existed the only way
// out was to pick a different English msgid — see the comment at
// nest-app/components/feature/Inbox/inboxFolders.ts, which did exactly that for "Done" vs
// "Resolved".
export const pgettext = (context: string, text: string) =>
  window.pgettext(context, text);

// i.e. "Page %s of %s" -> "Page 1 of 2" where values = [1, 2]
export const interpolate = (text: string, values: (string | number)[]) =>
  window.interpolate(text, values);
